<template>
  <j-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    switchFullscreen
    :fullscreen="true"
    @ok="handleOk"
    @cancel="handleCancel">

    <template slot="footer">
      <a-button v-if="action!=='detail'" key="cancel" @click="handleCancel">取消</a-button>
      <a-button v-if="!readOnly" key="save"   @click="handleSave" type="primary" :loading="confirmLoading">保存</a-button>
      <a-button v-if="!readOnly" key="submit" @click="handleSubmit" type="primary" :loading="confirmLoading">提交</a-button>
      <a-button v-if="action==='detail'"  key="close"  @click="handleCancel" type="primary">关闭</a-button>
      <a-button v-if="action==='approve'"  key="approved"  @click="handleApproved" type="primary">审核通过</a-button>
    </template>


    <a-spin :spinning="confirmLoading">
      <!-- 主表单区域 -->
      <a-form :form="form">

        <a-row>
          <a-col :xs="24" :sm="8">
            <a-form-item label="单据编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['billNo']" placeholder="请输入单据编号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="8">
            <a-form-item label="单据日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date disabled placeholder="请选择单据日期" v-decorator="['billDate']" :trigger-change="true"
                      style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="8" style="display: none">
            <a-form-item label="单据状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['billStatus']" :trigger-change="true"
                                 dictCode="x_bill_proc_status" placeholder="请选择单据状态"/>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="8">
            <a-form-item label="所属门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag :disabled="readOnly" type="list" v-decorator="['storeId', validatorRules.storeId]" :trigger-change="true"
                                 dictCode="sales_physical_store,phystore_name,id" placeholder="请选择所属门店"/>
            </a-form-item>
          </a-col>
<!--          <a-col :xs="24" :sm="8">-->
<!--            <a-form-item label="经办人员" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <j-select-user-by-dep :disabled="readOnly" v-decorator="['handlerId',validatorRules.handlerId]"-->
<!--                                    :trigger-change="true" @change="handleHandlerChange($event)"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :xs="24" :sm="8">-->
<!--            <a-form-item label="审核人" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <j-select-user-by-dep disabled v-decorator="['approverId']" :trigger-change="true"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :xs="24" :sm="8">-->
<!--            <a-form-item label="流程id" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <a-input disabled v-decorator="['flowId']" placeholder="请输入流程id"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :xs="24" :sm="8">-->
<!--            <a-form-item label="是否通过" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <j-dict-select-tag disabled type="list" v-decorator="['isApproved']" :trigger-change="true" dictCode="yn"-->
<!--                                 placeholder="请选择是否通过"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :xs="24" :sm="8">-->
<!--            <a-form-item label="生效时间" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <j-date disabled placeholder="请选择生效时间" v-decorator="['effectiveTime']" :trigger-change="true"-->
<!--                      style="width: 100%"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :xs="24" :sm="8">-->
<!--            <a-form-item label="是否作废" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <j-dict-select-tag disabled type="list" v-decorator="['isVoided']" :trigger-change="true" dictCode="yn"-->
<!--                                 placeholder="请选择是否作废"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :xs="24" :sm="8">-->
<!--            <a-form-item label="是否关闭" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <j-dict-select-tag disabled type="list" v-decorator="['isClosed']" :trigger-change="true" dictCode="yn"-->
<!--                                 placeholder="请选择是否关闭"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->


        </a-row>
      </a-form>

      <!-- 子表单区域 -->
      <a-tabs v-model="activeKey" @change="handleChangeTabs">
        <a-tab-pane tab="要货申请明细" :key="refKeys[0]" :forceRender="true">
          <j-editable-table
            :ref="refKeys[0]"
            :loading="stkRequestEntryTable.loading"
            :columns="stkRequestEntryTable.columns"
            :dataSource="stkRequestEntryTable.dataSource"
            :maxHeight="tableHeight"
            :rowNumber="true"
            :rowSelection="true"
            :actionButton="true">

            <template v-slot:batchNoSelectModal="props" style="padding-left: 0">
              <a-button :disabled="readOnly" @click="handleBatchNoSelect(props)" icon="">选择物料</a-button>
             <!-- <onl-cgreport-select-modal
                ref="selectModal"
                title="选择物料"
                reportId="1393482678581661698"
                :width="1100"
                :multiSelectable="true"
                :params = "materialReportParam"
                @callback="(selectedRows)=>handleBatchNoSelectCallback(props,selectedRows)"/>-->
              <material-select-modal
                ref="selectMaterialModal"
                title="选择物料"
                filterCode=""
                :width="1100"
                @callback="(selectedRows)=>handleBatchNoSelectCallback(props,selectedRows)"/>
            </template>



          </j-editable-table>
        </a-tab-pane>

      </a-tabs>

    </a-spin>
  </j-modal>
</template>

<script>

import pick from 'lodash.pick'
import {FormTypes, getRefPromise, VALIDATE_NO_PASSED, validateFormAndTables} from '@/utils/JEditableTableUtil'
import {JEditableTableMixin} from '@/mixins/JEditableTableMixin'
import {validateDuplicateValue} from '@/utils/util'
import JDate from '@/components/jeecg/JDate'
import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
import JDictSelectTag from "@/components/dict/JDictSelectTag"
import {getFormatDate} from "@views/erp/utils/util";
import {putAction,getAction} from "@/api/manage";
import {mapGetters} from 'vuex'
import OnlCgreportSelectModal from '../../components/OnlCgreportSelectModal'
import MaterialSelectModal from '../../components/MaterialSelectModal'
import {postAction} from "../../../../api/manage";

export default {
  name: 'StkRequestInModal',
  mixins: [JEditableTableMixin],
  components: {
    JDate,
    JSelectUserByDep,
    JDictSelectTag,
    OnlCgreportSelectModal,
    MaterialSelectModal
  },
  data() {
    return {
      module_sign:"goods_apply",
      action: '',
      materialReportParam : {},
      labelCol: {
        xs: {span: 24},
        sm: {span: 6},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      labelCol2: {
        xs: {span: 24},
        sm: {span: 3},
      },
      wrapperCol2: {
        xs: {span: 24},
        sm: {span: 20},
      },
      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      validatorRules: {
        handlerId: {
          rules: [
            {required: true, message: '请选择经办人!'},
          ]
        },
        storeId: {
          rules: [
            {required: true, message: '请选择门店!'},
          ]
        },
      },
      refKeys: ['stkRequestEntry',],
      tableKeys: ['stkRequestEntry',],
      activeKey: 'stkRequestEntry',
      // 要货申请明细
      stkRequestEntryTable: {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: '物料',
            key: 'materialId',
            type: FormTypes.sel_search,
            dictCode: "bas_material,name,id",
            width: "200px",
            placeholder: '请输入${title}',
            defaultValue: '',
            validateRules: [{required: true, message: '${title}不能为空'}],
            disabled:true
          },
          {
            title: '',
            key: 'batchNoSelectModal',
            type: FormTypes.slot,
            slotName: 'batchNoSelectModal',
            orgFields: "id,unit_id",
            destFields: "materialId,unitId",
            width:"100px",
          },
          {
            title: '计量单位',
            key: 'unitId',
            type: FormTypes.select,
            dictCode: "bas_measure_unit,name,id",
            width: "200px",
            placeholder: '请输入${title}',
            defaultValue: '',
          },
          {
            title: '数量',
            key: 'qty',
            type: FormTypes.input,
            width: "200px",
            placeholder: '请输入${title}',
            defaultValue: '',
          },
        ]
      },
      url: {
        add: "/stock/stkRequestIn/add",
        edit: "/stock/stkRequestIn/edit",
        stkRequestEntry: {
          list: '/stock/stkRequestIn/queryStkRequestEntryByMainId'
        },
        approve: "/stock/stkRequestIn/approve",
        findStoreByUser: "/sales/salesPhysicalStore/findStoreByUser",
        batchGetMapperUnitIdBySign: "/bas/basMaterial/batchGetMapperUnitIdBySign",
      }
    }
  },
  computed: {
    readOnly: function() {
      return this.action !== "add" && this.action !== "edit";
    },
    tableHeight: function(){
      this.$parent.$children.forEach((child)=>{
        if(child.$vnode.tag.indexOf("AForm")>-1){
          return this.$root.$el.clientHeight - child.$el.clientHeight
        }
      })
    }
  },
  methods: {
    ...mapGetters(["nickname", "avatar","userInfo"]),
    getAllTable() {
      let values = this.tableKeys.map(key => getRefPromise(this, key))
      return Promise.all(values)
    },
    addInit() {
      //处理状态：编辑中
      this.model.billStatus = '12'
      this.stkRequestEntryTable.dataSource = []
      const url = '/sys/fillRule/executeRuleByCode/'
      const ruleCode = 'stock_io_bill_no'
      const that = this
      putAction(url + ruleCode, {}).then(res => {
        // 执行成功，获取返回的值，并赋到页面上
        if (res.success) {
          that.model.billNo = res.result;
          that.$nextTick(() => {
            that.form.setFieldsValue({'billNo':res.result, 'billDate':getFormatDate()});
            //初始空白行增加时，billNo可能还未生成！
            let { values } = this.$refs.stkRequestEntry.getValuesSync({ validate: false});
            for (let v of values) {
              that.$refs.stkRequestEntry.setValues([{rowKey: v.id, values: {batchNo: that.model.billNo +'-' + v.entryNo}}]);
            }
            that.form.setFieldsValue({'handlerId':that.userInfo().username})
            that.handleHandlerChange(that.userInfo().username)
          })
        }
      })
    },
    /** 调用完edit()方法之后会自动调用此方法 */
    editAfter() {
      if (this.action === 'add') {
        this.addInit();
      }
      let fieldval = pick(this.model, 'createBy', 'createTime', 'updateBy', 'updateTime', 'billNo', 'billDate', 'storeId', 'handlerId', 'billStatus', 'approverId', 'flowId', 'isApproved', 'effectiveTime', 'isVoided', 'isClosed')
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldval)
        this.materialReportParam = {storeId:this.model.storeId}
        // 加载子表数据
        if (this.model.id) {
          let params = {id: this.model.id}
          this.requestSubTableData(this.url.stkRequestEntry.list, params, this.stkRequestEntryTable)
        }
      })
    },
    /** 整理成formData */
    classifyIntoFormData(allValues) {
      let main = Object.assign(this.model, allValues.formValue)
      return {
        ...main, // 展开
        stkRequestEntryList: allValues.tablesValue[0].values,
      }
    },
    validateError(msg) {
      this.$message.error(msg)
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'createBy', 'createTime', 'updateBy', 'updateTime', 'billNo', 'billDate', 'storeId', 'handlerId', 'billStatus', 'approverId', 'flowId', 'isApproved', 'effectiveTime', 'isVoided', 'isClosed'))
    },
    handleApproved() {
      const that = this;
      putAction(that.url.approve, {id: that.model.id}).then((res) => {
        if (res.success) {
          that.$message.success(res.message);
          that.$emit('ok')
          that.close()
        } else {
          that.$message.warning(res.message);
        }
      })
    },
    handleHandlerChange(event){
      const that = this;
      getAction(this.url.findStoreByUser,{userCode:event}).then((res)=>{
        if (res.success){
          that.form.setFieldsValue({'storeId':res.result.id})
          // this.stkRequestEntryTable.columns[0].dictCode = 'bas_material,name,id,store_id like "%'+res.result.id+'%"'
        }else{
          that.form.setFieldsValue({'storeId':''})
        }
      })
    },
    handleBatchNoSelect(props){
      let queryParams = {};
      let orgStoreId = 'material_store'
      queryParams[orgStoreId] = ''
      let storeId = this.form.getFieldValue('storeId')
      if(storeId){
        queryParams[orgStoreId] = '*'+storeId+'*'
      }
      this.$refs.selectMaterialModal.initQueryParams(queryParams);
      this.$refs.selectMaterialModal.visible = true;
    },

    testHandleSelect(props){
      this.$refs.selectMaterialModal.initQueryParams();
      this.$refs.selectMaterialModal.visible = true;
    },
    handleBatchNoSelectCallback(props, selectedRows){
      if (selectedRows) {
        let valArr = [];
        for(let i = 0; i < selectedRows.length; i++) {
          let materialId = selectedRows[i].id;
          let unitId = selectedRows[i].unit_id;
          valArr.push({"materialId":materialId,"unitId":unitId});
        }
        if (valArr) {
          postAction(this.url.batchGetMapperUnitIdBySign,{data:valArr,moduleSign:this.module_sign}).then((res) => {
            if (res.success) {
              let newData = res.result;
              //将查询的新计量单位插入selectedRows
              for(let z = 0; z < selectedRows.length; z++) {
                let orgMaterialId = selectedRows[z].id;
                for (let w = 0; w <newData.length  ; w++) {
                  let targetMaterialId = newData[w].materialId;
                  if (orgMaterialId === targetMaterialId){
                    let newUnitId = newData[w].unitId;
                    selectedRows[z].unit_id = newUnitId;
                    break;
                  }
                }
              }
              let { rowId, target } = props;
              let orgFields = props.column.orgFields.split(',');
              let destFields = props.column.destFields.split(',');
              for(let i = 0; i < selectedRows.length; i++) {
                let values = {};
                for (let j = 0; j < orgFields.length; j++) {
                  values[destFields[j]] = selectedRows[i][orgFields[j]];
                }

                if (i === 0) {
                  target.setValues([{rowKey: rowId, values: values}]);
                } else {
                  target.add();
                  let rowId2 = target.rows[target.rows.length - 1].id;
                  target.setValues([{rowKey: rowId2, values: values}]);
                }
              }
            }
          })
        }
      }
    },
    handleSubmit() {
      //处理状态=编辑完成
      this.form.setFieldsValue({billStatus:'13'})

      //出错时要恢复billProcStatus为"12"，所以下面未直接调用handleSave()！

      /** 触发表单验证 */
      this.getAllTable().then(tables => {
        /** 一次性验证主表和所有的次表 */
        return validateFormAndTables(this.form, tables)
      }).then(allValues => {
        if (typeof this.classifyIntoFormData !== 'function') {
          throw this.throwNotFunction('classifyIntoFormData')
        }
        let formData = this.classifyIntoFormData(allValues)
        // 发起请求
        return this.request(formData)
      }).catch(e => {
        //处理状态=编辑中
        this.form.setFieldsValue({billStatus:'12'})

        if (e.error === VALIDATE_NO_PASSED) {
          // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
          this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
        } else {
          console.error(e)
        }
      })
    },

    handleSave() {
      this.handleOk()
    },
  }
}
</script>

<style scoped>
</style>